'use client';

import { ArrowLeft, FileText, UserRound } from 'lucide-react';
import { useEffect, useState } from 'react';
import { formatGameKeeDate, getUserPosts, type GameKeePost } from '../lib/gamekee-api';
import './user-posts-page.css';

export default function UserPostsPage({ uid }: { uid: number }) {
  const [posts, setPosts] = useState<GameKeePost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getUserPosts(uid)
      .then(result => setPosts(result.items))
      .catch(reason => setError(reason instanceof Error ? reason.message : '帖子加载失败'))
      .finally(() => setLoading(false));
  }, [uid]);

  const author = posts[0]?.user;
  return <main className="user-posts-page">
    <header><a href="/arcanatactics/dcommunity"><ArrowLeft/>返回社区</a><span>USER POSTS</span></header>
    <section className="user-posts-card">
      <div className="user-posts-identity">
        {author?.avatar ? <img src={author.avatar} alt=""/> : <i><UserRound/></i>}
        <div><h1>{author?.username || `用户 ${uid}`}</h1><p>UID {uid} · {posts.length} 篇公开帖子</p></div>
      </div>
      {loading ? <Status title="正在加载帖子" text="正在从 GameKee 获取公开内容。"/> : error ? <Status title="帖子加载失败" text={error}/> : posts.length ? <div className="user-post-list">{posts.map(post => <a href={`/arcanatactics/${post.id}`} key={post.id}>{(post.thumb || post.cover) && <img src={post.thumb || post.cover || ''} alt=""/>}<div><h2>{post.title || '未命名帖子'}</h2>{(post.summary || post.description) && <p>{post.summary || post.description}</p>}<small>{formatGameKeeDate(post.created_at)} · {post.view_count || 0} 次浏览 · {post.comment_count || 0} 条评论</small></div></a>)}</div> : <Status title="暂无公开帖子" text="这位用户目前还没有公开内容。"/>}
    </section>
  </main>;
}

function Status({ title, text }: { title: string; text: string }) {
  return <div className="user-post-status"><FileText/><strong>{title}</strong><p>{text}</p></div>;
}
